var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentTag,_vm._g(_vm._b({tag:"component",staticClass:"ctaButton",class:[
    _vm.sizeClass,
    _vm.variantClass,
    {
      'ctaButton--fluid': _vm.fullWidth,
      'ctaButton--noIcon': !_vm.showIcon,
    } ],style:(_vm.widthStyle),on:{"click":_vm.handleClick}},'component',_vm.componentAttrs,false),_vm.$listeners),[_c('span',{staticClass:"ctaButton__text"},[_vm._v(_vm._s(_vm.label))]),(_vm.showIcon)?_c('span',{staticClass:"ctaButton__icon",attrs:{"aria-hidden":"true"}},[_c('svg',{attrs:{"viewBox":"0 0 24 24","fill":"none"}},[_c('path',{attrs:{"d":"M5 12h12m0 0-5-5m5 5-5 5","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }